export const NAME_ORIGIN_WEALTH_PROVENANCE = {
  1: 'BIENES MUEBLES E INMUEBLES POR HERENCIA',
  2: 'BIENES MUEBLES E INMUEBLES',
  3: 'NEGOCIO PROPIO',
  4: 'SERVICIOS PROFESIONALES',
  5: 'PRÉSTAMOS BANCARIOS',
  6: 'TRABAJOS ANTERIORES',
  7: 'TRABAJO ACTUAL',
  8: 'OTRO'
} as const

export const TYPE_ORIGIN_WEALTH_PROVENANCE = {
  INHERITANCE: '1',
  FURNITURE_AND_REAL_ESTATE: '2',
  OWN_BUSINESS: '3',
  PROFESSIONAL_SERVICES: '4',
  BANK_LOANS: '5',
  PREVIOUS_WORKS: '6',
  CURRENT_WORK: '7',
  OTHER: '8'
} as const

export type TypeOriginWealthProvenance =
  (typeof TYPE_ORIGIN_WEALTH_PROVENANCE)[keyof typeof TYPE_ORIGIN_WEALTH_PROVENANCE]

export const CATALOG_ORIGIN_WEALTH_PROVENANCE = [
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.INHERITANCE,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.INHERITANCE]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.FURNITURE_AND_REAL_ESTATE,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.FURNITURE_AND_REAL_ESTATE]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.OWN_BUSINESS,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.OWN_BUSINESS]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.PROFESSIONAL_SERVICES,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.PROFESSIONAL_SERVICES]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.BANK_LOANS,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.BANK_LOANS]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.PREVIOUS_WORKS,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.PREVIOUS_WORKS]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.CURRENT_WORK,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.CURRENT_WORK]
  },
  {
    value: TYPE_ORIGIN_WEALTH_PROVENANCE.OTHER,
    label: NAME_ORIGIN_WEALTH_PROVENANCE[TYPE_ORIGIN_WEALTH_PROVENANCE.OTHER]
  }
]
